<template>
  <Modal
    :title="$t('more_information_video_why_header')"
    :buttonLabel="$t('button_close')"
  >
    <template v-slot:activator="{ on, attrs }">
      <p>
        <a v-bind="attrs" v-on="on">{{
          $t('camera_status_more_information')
        }}</a>
      </p>
    </template>

    {{ $t('more_information_video_why_detail') }}
  </Modal>
</template>

<script>
import { Modal } from '@neurotrack/web-shared-components'

export default {
  components: { Modal }
}
</script>
